import CBREModule from './CBREModule';

export default CBREModule;
